/**
 * Agent-specific metric names.
 * These will be prefixed with "contactcenter_fe_" by the BFF.
 */
export const AgentMetricNames = {
  STATUS_CHANGE_TOTAL: 'status_change_total',
} as const;

/**
 * Agent-specific metric tags.
 */
export const AgentMetricTags = {
  AGENT_STATUS_FROM: 'agent_status_from',
  AGENT_STATUS_TO: 'agent_status_to',
  SOURCE: 'source',
} as const;

/**
 * Source values for tracking where an action originated.
 * Used with AgentMetricTags.SOURCE for agent status changes.
 */
export const Source = {
  MANUAL: 'manual',
  AUTOMATIC: 'automatic',
  SYSTEM: 'system',
} as const;

/**
 * Operation names for agent-related metrics.
 */
export const AgentOperationNames = {
  SESSION_OFFERED: 'session_offered',
  CLASSIFICATION: 'classification',
} as const;
